import { render, staticRenderFns } from "./new-rfa-batch.vue?vue&type=template&id=81bce0f8&"
import script from "./new-rfa-batch.vue?vue&type=script&lang=js&"
export * from "./new-rfa-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports